import React from "react";

function PageWrapperComponent({ children }) {
  return <>{children}</>;
}

export default PageWrapperComponent;
